export default {
  api: {
    baseUrl: '',
    chatUrl: '',
  },
};
